var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoldingsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2076 2.23993C11.6874 1.92002 12.3126 1.92002 12.7924 2.23993L21.3639 7.95421C21.72 8.19161 21.9509 8.57618 21.993 9.00208C22.0352 9.428 21.8842 9.85037 21.5816 10.153L21.1572 10.5774C20.7822 10.9524 20.5714 11.4612 20.5714 11.9916V16.3349C20.5714 17.1656 21.1727 17.8707 21.6321 18.5629C21.8646 18.9133 22 19.3337 22 19.7857C22 21.0086 21.0086 22 19.7857 22H4.21429C2.99137 22 2 21.0086 2 19.7857C2 19.3337 2.13544 18.9133 2.36794 18.5629C2.82727 17.8707 3.42857 17.1656 3.42857 16.3348V11.9916C3.42857 11.4612 3.21786 10.9524 2.84279 10.5774L2.41843 10.153C2.11579 9.85037 1.96479 9.428 2.00696 9.00208C2.04913 8.57618 2.28005 8.19161 2.63615 7.95421L11.2076 2.23993ZM14.8572 10.5714C15.6462 10.5714 16.2857 11.211 16.2857 12V16.2857C16.2857 17.0747 15.6462 17.7143 14.8572 17.7143C14.0682 17.7143 13.4286 17.0747 13.4286 16.2857V12C13.4286 11.211 14.0682 10.5714 14.8572 10.5714ZM10.5714 12C10.5714 11.211 9.93183 10.5714 9.14286 10.5714C8.35387 10.5714 7.71429 11.211 7.71429 12V16.2857C7.71429 17.0747 8.35387 17.7143 9.14286 17.7143C9.93183 17.7143 10.5714 17.0747 10.5714 16.2857V12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldingsActive);
export default __webpack_public_path__ + "static/media/holdings-active.2eb929b095da062660c014eb8dfd4fdd.svg";
export { ForwardRef as ReactComponent };